import Icon, { ICONS } from "@general-ui/icon";
import Switch from "@general-ui/switch/switch";
import { useTranslate } from "i18n/useTranslationModules";
import { useDispatch } from "react-redux";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { setEventNavOpen } from "store/actions/event/event-actions";
import { BrandliveEvent } from "types/working-model";
import { useCurrentPageState } from "./navbar.hooks";
import useToggleAttendeeInPersonMode from "../hooks/use-toggle-attendee-in-person-mode";
import { useTypedSelector } from "store/reducers/use-typed-selector";
import { selectAttendeeInPersonEnabled } from "store/selectors/live-event";
import { handleLinkKeyDown } from "utils/keyboard-activation";

type Props = {
	userProfile: Record<number, string> | undefined;
	eventBundle: BrandliveEvent;
}
const NavbarProfileCard: React.FC<Props> = ({ userProfile, eventBundle }) => {
	const { t } = useTranslate('homepage');
	const params = useParams();
	const navigate = useNavigate();
	const pageState = useCurrentPageState(eventBundle);
	const dispatch = useDispatch();
	const toggleAttendeeInPerson = useToggleAttendeeInPersonMode();
	const attendeeInPersonToggleIsOn = useTypedSelector(selectAttendeeInPersonEnabled);
	const attendeeInPersonEnabled = !!eventBundle?.registration_settings?.adminInPersonAttendeeModeEnabled;

	const goToProfile = () => {
		try {
			const path = generatePath(pageState.routeMap.Profile, { ...params });

			navigate(path);

			dispatch(setEventNavOpen(false));
		} catch (e) {
			console.error(`Unable to route to profile`, e);
		}
	};

	const toggleInPersonView = (_: unknown, on: boolean) => {
		toggleAttendeeInPerson(on);
	};

	return (
		<div className="navbar__mobile-header-profile-card">
			<div className="navbar__mobile-header-profile-card-upper" onClick={goToProfile} onKeyDown={handleLinkKeyDown} role="link" tabIndex={0}>
				<div className="navbar__mobile-header-profile-card-upper-name">
					<label>{userProfile?.[1]} {userProfile?.[2]}</label>
					<aside role="none">{t('See your profile', 'See your profile')}</aside>
				</div>
				<div className="navbar__mobile-header-profile-card-upper-icon">
					<Icon name={ICONS.ANGLE_RIGHT} color={''} size={16} />
				</div>
			</div>
			{attendeeInPersonEnabled && (
				<div className="navbar__mobile-header-profile-card-lower">
					<label>{t('In-person view', 'In-person view')}</label>
					<Switch
						value="in-person"
						on={attendeeInPersonToggleIsOn}
						onClick={toggleInPersonView}
						ariaLabel={t('In-person view', 'In-person view')}
					/>
				</div>
			)}

		</div>
	);
};

export default NavbarProfileCard;